// extracted by mini-css-extract-plugin
export default {"container":"app-loading-error_container__dHIlx"};